// extracted by mini-css-extract-plugin
module.exports = {"footerCard":"FooterCard_footerCard__xOsrK"};